"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exactBoundingRect = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils");
/**
 * bitMatrix = {
 *   width: 6,
 *   height: 6,
 *   data: [
 *     [0, 0, 0, 0, 0, 0],
 *     [0, 0, 0, 0, 0, 0],
 *     [0, 1, 1, 1, 0, 0],
 *     [0, 1, 1, 1, 1, 0],
 *     [0, 0, 1, 1, 1, 0],
 *     [0, 0, 0, 0, 0, 0]
 *   ]
 * }
 *
 * のとき、
 * Rect({ top: 2, left: 1, width: 4, height: 3 })
 * を返す
 *
 */
var exactBoundingRect = function (bitMatrix) {
    var width = bitMatrix.width, height = bitMatrix.height;
    var _a = tslib_1.__read([height - 1, width - 1, 0, 0], 4), top = _a[0], left = _a[1], right = _a[2], bottom = _a[3]; // outmost position of non-zero value
    for (var y = 0; y < height; ++y) {
        for (var x = 0; x < width; ++x) {
            if (bitMatrix.data.get(y * width + x, 0) > 0) {
                // data(y, x) is non-zero
                if (y < top) {
                    top = y;
                }
                if (x < left) {
                    left = x;
                }
                if (right < x) {
                    right = x;
                }
                if (bottom < y) {
                    bottom = y;
                }
            }
        }
    }
    return (0, utils_1.IRect)({ top: top, left: left, width: right - left, height: bottom - top });
};
exports.exactBoundingRect = exactBoundingRect;
